module.exports = __webpack_public_path__ + "img/AssetsBranding-17.387aa623.svg";